/**
 * TextArea Component
 */

import { getColorSchemeClassName } from '../../../styles/color-schemes';
import './styles.scss';

import * as classNames from 'classnames';
import { clone, isEqual } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form';

import { Span } from '../../text/Label';

interface IOwnProps {
  autoFocus?: boolean;
  className?: string;
  colorScheme?: 'light' | 'white';
  disabled?: boolean;
  input?: WrappedFieldInputProps;
  inputProps?: any;
  isControlled?: boolean;
  meta?: WrappedFieldMetaProps<any>;
  name: string;
  onBlur?: (event: any, value: string | number) => void;
  onChange?: (event: any, value: string | number) => void;
  onFocus?: (event: any, value: string | number) => void;
  onlyValidateIfTouched?: boolean;
  optional?: boolean;
  placeholder?: string;
  size?: TextFieldSize;
  style?: any;
  value?: string | number;
}

export type TextAreaProps = IOwnProps;

interface IOwnState {
  isFocus: boolean;
  value: string | number;
}

const classes = new BEM('textarea');

export default class TextArea extends React.Component<IOwnProps, IOwnState> {
  static defaultProps: Partial<IOwnProps> = {
    optional: false,
    size: 'medium',
  };

  constructor(props: IOwnProps) {
    super(props);

    this.state = {
      isFocus: false,
      value: this.props.value || '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isControlled || !nextProps.value) {
      return;
    }

    if (this.state.value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  shouldComponentUpdate(nextProps: IOwnProps, nextState) {
    return !(isEqual(nextProps, this.props) && isEqual(nextState, this.state));
  }

  render() {
    /* tslint:disable:no-unused-variable */
    const {
      autoFocus,
      children,
      className,
      colorScheme,
      disabled,
      input,
      inputProps,
      meta,
      name = this.props.input ? this.props.input.name : '',
      onlyValidateIfTouched,
      placeholder,
      size,
      style,
    } = this.props;

    const modifiers = {
      'is-focus': this.state.isFocus,
      'is-disabled': disabled,
      [size!]: size,
      'error': meta && meta.touched && meta.error,
      'warning': meta && meta.touched && meta.warning,
    };

    const extraClasses = classNames(
      colorScheme && getColorSchemeClassName(colorScheme, 'textarea'),
      className,
    );

    const inputControlProps = input ?
      {
        onFocus: (e) => { this.onToggleFocus(e); input.onFocus(e, e.target.value, null); },
        onBlur: (e) => { this.onToggleFocus(e); input.onBlur(e, e.target.value, null); },
        onChange: (e) => { this.onChange(e); input.onChange(e, e.target.value, null); },
        value: input.value,
      } : {
        onFocus: this.onToggleFocus,
        onBlur: this.onToggleFocus,
        onChange: this.onChange,
        value: this.state.value,
      };

    const labelClasses = new BEM('label');

    return (
      <div {...classes('', modifiers, extraClasses) } style={style}>
        <div {...classes('background') } />
        {children}
        {meta && (
          (((onlyValidateIfTouched && meta.touched) || !onlyValidateIfTouched) &&
            (meta.error &&
              <Span {...labelClasses('', 'error') } size="medium" textColor="dangerous">{meta.error}</Span>) ||
            (meta.warning &&
              <Span {...labelClasses('', 'warning') } size="medium">{meta.warning}</Span>)
          )
        )}
        <textarea
          id={name}
          name={name}
          {...classes('input') }
          placeholder={placeholder}
          autoFocus={autoFocus}
          {...inputControlProps}
          {...inputProps}
        />
      </div>
    );
  }

  private onChange = (e) => {
    const event = clone(e);
    const newValue = e.target.value;

    this.setState({ value: newValue }, () => {
      if (this.props.onChange) {
        this.props.onChange(event, newValue);
      }
    });
  }

  private onToggleFocus = (e) => {
    const event = clone(e);
    const eventType = e.type;
    const { value } = this.state;

    if (eventType === 'focus') {
      e.target.select();
    }

    this.setState({
      isFocus: eventType === 'focus' ? true : false,
    }, () => {
      /* tslint:disable:no-unused-expression */
      (eventType === 'focus' && this.props.onFocus) && this.props.onFocus(event, value);
      (eventType === 'blur' && this.props.onBlur) && this.props.onBlur(event, value);
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/forms/TextArea/index.tsx